// src/routes/MainRoutes.tsx
import {Navigate} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute.tsx";
import MainPage from "../pages/MainPage.tsx";

const MainRoutes = {
  element: <ProtectedRoute/>,
  children: [
    {path: "/", element: <MainPage/>},
    {path: "/updates-and-faq", element: <Navigate replace to="/"/>},
  ],
};

export default MainRoutes;
